import { PrintCodes } from './PrintCodes';

export default PrintCodes;
